import React from 'react';

const Tab = ({ label, onClick, activeTab }) => {
  const className = activeTab === label ? 'active' : '';

  return (
    <li className={className}>
      <button type="button" onClick={() => onClick(label)}>{label}</button>
    </li>
  );
};

export default Tab;
